export const folderColorValues = [
  'yellow',
  'blue',
  'green',
  'red',
  'orange',
  'purple',
  'teal',
  'gray',
] as const;

export type FolderColorValue = (typeof folderColorValues)[number];

export interface FolderColorOption {
  value: FolderColorValue;
  className: string;
  hex: string;
  label: string;
}

export const defaultFolderColor: FolderColorValue = 'yellow';

export const folderColorOptions: FolderColorOption[] = [
  {
    value: 'yellow',
    className: 'folder-file-color--yellow',
    hex: '#fbc02d',
    label: 'Yellow',
  },
  {
    value: 'blue',
    className: 'folder-file-color--blue',
    hex: '#42a5f5',
    label: 'Blue',
  },
  {
    value: 'green',
    className: 'folder-file-color--green',
    hex: '#66bb6a',
    label: 'Green',
  },
  {
    value: 'red',
    className: 'folder-file-color--red',
    hex: '#ef5350',
    label: 'Red',
  },
  {
    value: 'orange',
    className: 'folder-file-color--orange',
    hex: '#ff9800',
    label: 'Orange',
  },
  {
    value: 'purple',
    className: 'folder-file-color--purple',
    hex: '#ab47bc',
    label: 'Purple',
  },
  {
    value: 'teal',
    className: 'folder-file-color--teal',
    hex: '#26a69a',
    label: 'Teal',
  },
  {
    value: 'gray',
    className: 'folder-file-color--gray',
    hex: '#78909c',
    label: 'Gray',
  },
];

export function isFolderColorValue(value: unknown): value is FolderColorValue {
  return (
    typeof value === 'string' &&
    folderColorValues.includes(value as FolderColorValue)
  );
}

export function getFolderColorClassName(color?: string | null): string {
  const option = folderColorOptions.find(item => item.value === color);
  return option?.className || 'folder-file-color';
}
